const UserFacingText = Object.freeze({
  NAME_SHOULD_NOT_BE_BLANK: "name should not be blank",
  EMAIL_SHOULD_NOT_BE_BLANK: "email should not be blank",
  EMAIL_DOESNT_MATCH: "email entries must match",
  CHOOSE_A_GAME: "choose a game",
  INVALID_PLAYER_COUNT: "invalid player count",
})

export default UserFacingText
